
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { IPrivateEndpointMetadata } from './private-endpoint-metadata';
import { getSqlControls, getReadonlyControl, synapseResourceIdFormat } from './shared-control-metadata';

export const synapseWorkspacePrivateEndpointMetadata: IPrivateEndpointMetadata = {
    resourceType: 'Microsoft.Synapse/workspaces',
    connectionSuffix: 'workspace_privateEndpointConnections_settings',
    resourceIdValidator: synapseResourceIdFormat,
    groupIdMetadata: {
        sqlOnDemand: {
            linkedServiceType: adfModelTypeMap.azureSqlDW.linkedServiceType,
            groupId: 'sqlOnDemand',
            groupIdFamily: 'synapseWorkspace',
            iconClass: 'svg-i-100x100-SQLPool',
            displayName: '',
            customDefaultNamePrefix: 'AzureSynapseAnalytics',
            disablePublish: true,

            // TODO: Remove controls
            controls: {
                creationControls: getSqlControls(true),
                readonlyControls: getReadonlyControl()
            }
        },
        sql: {
            linkedServiceType: adfModelTypeMap.azureSqlDW.linkedServiceType,
            groupId: 'sql',
            groupIdFamily: 'synapseWorkspace',
            iconClass: 'svg-i-100x100-SQLPool',
            displayName: stringResources.AzureSynapseAnalytics,
            customDefaultNamePrefix: 'AzureSynapseAnalytics',

            // TODO: Remove controls
            controls: {
                creationControls: getSqlControls(true),
                readonlyControls: getReadonlyControl()
            }
        },
        dev: {
            linkedServiceType: 'dev',
            groupId: 'dev',
            groupIdFamily: 'synapseWorkspace',
            iconClass: 'svg-arcadia',
            displayName: '',
            disablePublish: true,

            // TODO: Remove controls
            controls: {
                creationControls: getSqlControls(true),
                readonlyControls: getReadonlyControl()
            }
        }
    },
    groupIdFamilyMetadata: {
        synapseWorkspace: {
            linkedServiceType: adfModelTypeMap.azureSqlDW.linkedServiceType,
            displayName: stringResources.AzureSynapseAnalytics,
            customDefaultNamePrefix: 'AzureSynapseAnalytics',
            iconClass: 'svg-i-100x100-SQLPool',
            controls: {
                creationControls: getSqlControls(true, false, ['sql', 'sqlOnDemand', 'dev']),
                readonlyControls: getReadonlyControl()
            }
        }
    }
};
